import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';

export default {
  data() {
    return {
      // 全局通用属性
      isDev: process.env.NODE_ENV === 'development',
      isUs: `${Cookies.get('nonMetric')}` === '1',
      ossConfig: {},
      beforeToday: {
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
    };
  },
  computed: {
    // 登录用户信息
    userInfo() {
      return this.$store.state.userInfo;
    },
    // (PF-平台，HQ-总部，SC-售后公司)，CO-大客户，JV-代理，CS-客户
    isCoJv() {
      return this.$store.state.userInfo && (this.$store.state.userInfo.bizType === 'CO' || this.$store.state.userInfo.bizType === 'JV');
    },
    // CO/JV是否显示租赁方
    showSubsidiary() {
      return Cookies.get('showSubsidiary') === 'true';
    },
  },
  methods: {
    // 转换上午下午
    momentAmPm: function (dataStr) {
      if (!dataStr) {
        return dataStr;
      }
      return this.isDev ? dataStr : dataStr.replace('am', this.$t('com_am')).replace('pm', this.$t('com_pm'));
    },
    // 获取paymentCode
    getPaymentCode(item) {
      return item.paymentCode || item.billPaymentCode;
    },
    // this.getAttachUrl(item)  getAttachUrl(item)
    // 获取文件可访问地址
    getAttachUrl(item = {}) {
      const isFullImgUrl = /^http/;
      const { attachPath = '', attachUrl = '' } = item;
      return isFullImgUrl.test(attachPath) ? attachPath : attachUrl;
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    // 导出
    exportTable(apiKey, param) {
      this.$exportFlie(apis[apiKey], param);
    },
    // 标签关闭清除缓存
    clearKeepAlive: function (componentName) {
      const includeList = this.$store.state.vm.includeList;
      const includes = includeList.filter(t => t !== componentName);
      this.$store.commit('INCLUDELIST', includes);
    },
    // 路由跳转
    jump: async function (to, query, isReplace) {
      if (typeof to === 'number') {
        this.$router.go(to);
        return;
      }
      const method = isReplace ? 'replace' : 'push';
      const params = query || {};
      this.$router[method]({ path: to, query: params });
    },
    // 获取路由信息
    getJump: function (name, value) {
      value = typeof value === 'undefined' ? '' : value;
      return this.$route.query[name] || value;
    },
    // 跳转外链 (_blank,是否新tab)
    jumpOutside: function (path, _blank) {
      if (!path) {
        return;
      }
      if (_blank) {
        window.open(path);
        return;
      }
      window.location.href = path;
    },
    // 批量获取附件  key返回值修改的key默认是'attachPath' returnType返回的类型 默认是'String'
    formatAttachList: async function (list, bizKey, bizType, key = 'attachPath', returnType = 'String') {
      const bizIds = [...new Set(list.map(t => t[bizKey]).filter(Boolean))].join(',');
      if (!list || list.length === 0 || !bizIds) {
        return list;
      }
      const res = await this.$getJSON(apis.OssBatchAttach, { bizIds, bizType });
      list.forEach((item) => {
        const row = res.data.find(t => t.bizId === item[bizKey]) || {};
        if (row && returnType === 'Array') {
          if (Array.isArray(item[key])) {
            item[key].push(this.getAttachUrl(row));
          } else {
            item[key] = [this.getAttachUrl(row)];
          }
        } else {
          item[key] = this.getAttachUrl(row);
        }
      });
      return list;
    },
    // 格式化表格布局 ref='tb1'
    formatTable: function () {
      this.isAllColumn = !this.tableColumn.find(t => !t.selected);
      this.$nextTick(() => {
        if (this.$refs.tb1 && this.$refs.tb1.doLayout) {
          this.$refs.tb1.doLayout();
        }
      });
    },
    // 微信扫码登录
    wxScanLogin: function (appId, state = 'login') {
      const AuthUrl = 'https://open.weixin.qq.com/connect/qrconnect?';
      const redirectUri = encodeURI(`${window.location.origin}/wechatlogin`);
      const baseUrl = `${AuthUrl}appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login`;
      const wxLoginUrl = `${baseUrl}&state=${state}#wechat_redirect`;
      window.location.href = wxLoginUrl;
    },

    getFilePreviewUrl(file) {
      if (URL && URL.createObjectURL) {
        const url = URL.createObjectURL(file);
        return Promise.resolve(url);
      } else {
        return new Promise((resolve) => {
          const fileReader = new FileReader();

          fileReader.readAsDataURL(file);
          // 异步加载
          fileReader.onload = function (event) {
            resolve(event.target.result);
          };
        });
      }
    },

    /**
     * 合并两个数组，去除重复项
     * @param {Array} targetArr
     * @param {Array} sourceArr
     * @param {String} id 判断是否为重复项的标识
     * @return {Array} ret
     */
    mergeArr(targetArr, sourceArr, id) {
      const ret = [...targetArr];
      sourceArr.forEach((item) => {
        if (!targetArr.some(tItem => `${tItem[id]}` === `${item[id]}`)) {
          ret.push(item);
        }
      });
      return ret;
    },

    /**
     * 模糊查询
     * @param {array<object>} list
     * @param {array<string>} keys
     * @param {string} keywork
     * @return {array<object>} result
     */
    fuzzyQuery(list, keys, keywork) {
      return list.filter((item) => {
        const vals = keys.map(key => item[key]);
        return vals.some(val => val.includes(keywork));
      });
    },

    /**
     * 空值转默认值—
     * @param {array<object>} list
     * @param {array<string>} exclude
     * @return {array<object>} ret
     */
    nullValueToCrossbar(list, exclude = []) {
      list.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          if (!exclude.includes(key) && (!obj[key] || obj[key] === 'null' || obj[key] === '00:00' || obj[key] === 0)) {
            obj[key] = '-';
          }
        });
      });
      return list;
    },
  },
};
